import React from "react";

export const SingleWhatsappLogRow = ({ props }: any) => {
  const {
    template_name,
    notification_status,
    lead_phone_numbers,
    source,
    trigger_date,
    trigger_time,
    schedule_date,
    schedule_time,
  } = props;

  return(
    <tr>
          <td>{template_name}</td>
          <td>{lead_phone_numbers.join(", ")}</td>
          <td>{notification_status}</td>
          <td>{source}</td>
          <td>{schedule_date}</td>
          <td>{schedule_time}</td>
          <td>{trigger_date}</td>
          <td>{trigger_time}</td>
        </tr>
  )
};
